<template>
    <div style="height: 100%; position: relative;">
        <div id="x001" class="" style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"></div>
        <div class="center" style="position: absolute; bottom: 0; left: 0; right: 0;">
          <span class="dot bcPrimary"></span> {{ 'Nettoomsättning' | T }}
          <span class="dot result"></span> {{ 'Operativa kassaflöden' | T }}
        </div>
    </div>
</template>

<script>
    /* tslint:disable */
    import Highcharts from 'highcharts'
    import Vue from 'vue';
    import {colors} from '@/config';

    export default {
        name: "CashflowYears",
        components: {},
        props: {
            profitloss: Object,
            cashflow: Object,
        },

        mounted() {
            this.chart = new Highcharts.chart({

                chart: {
                    type: 'column',
                    renderTo: 'x001',
                    backgroundColor: 'transparent',
                },

                credits: {
                    enabled: false,
                },

                title: {
                    text: ''
                },

                legend: {
                    enabled: false
                },

                colors: [colors.Primary, colors.Tertiary],

                xAxis: {
                    categories: this.cashflow.sheets.map( s => s.DATE_TO.substr(0, 4) ).reverse(),
                    labels: {
                        style: { fontSize: '1rem', color: colors.Black, }
                    }
                },

                yAxis: [{
                    opposite: true,
                    allowDecimals: false,
                    title: {
                        text: ''
                    },
                    labels: {
                        formatter() { return Vue.options.filters.KR(this.value); },
                        style: { fontSize: '1rem', color: colors.DarkGrey }
                    },
                    tickPixelInterval: 150,
                    gridLineColor: colors.LightGrey,
                    plotLines: [{
                        color: colors.Black,
                        width: 2,
                        value: 0,
                        zIndex: 2,
                    }],
                }],

                tooltip: {
                    formatter: function () {
                        let p = this;
                        return this.series.tooltipOptions.tooltip.call(p);
                    },
                    style: { fontSize: '1.25rem', },
                    backgroundColor: colors.Light,
                },

                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderColor: colors.DarkGrey,
                    }
                },

                series: [{
                    name: Vue.prototype.$t('Nettoomsättning'),
                    data: this.profitloss.sheets.slice(0,this.cashflow.sheets.length).map( (s,i) => s.A ).reverse(),
                    tooltip: {
                        tooltip: function() {
                            return '<b>' + this.series.name + '<br>' + Vue.options.filters.TKR(this.y);
                        }
                    },
                    stack: 'a'
                },
                  {
                    name: Vue.prototype.$t('Operativa kassaflöden'),
                    data: this.cashflow.sheets.map( (s,i) => s.OperatingCashflow >= 0 ? {y: s.OperatingCashflow, color: colors.Green} : {y: s.OperatingCashflow, color: colors.Red} ).reverse(),
                    tooltip: {
                      tooltip: function() {
                        return '<b>' + this.series.name + '<br>' + Vue.options.filters.TKR(this.y);
                      }
                    },
                    stack: 'b'
                  }],
            });
        },

    }
</script>

<style scoped lang="scss">
    .dot {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: inline-block;
    }

    .primary {
        background: linear-gradient( -45deg, get('colors.Secondary'), get('colors.Secondary') 50%, get('colors.Primary') 50%);
        border-radius: 50%;
    }

    .result {
        background: linear-gradient( -45deg, #e70407, #e70407 50%, #a4e408 50%);
        border-radius: 50%;
    }

    .center {
        font-size: 1.2rem;
    }
</style>
